// extracted by mini-css-extract-plugin
export default {"hoverPortfolio":"CardNewsHome_hoverPortfolio__O81h0"};